import api from "../config/api";
import axios from "axios";
import { ServiceReturn } from "../types/ServiceResponse";

export interface RichLinkPreview {
  url: string;
  title?: string;
  description?: string;
  imageUrl?: string;
  siteName?: string;
  host: string;
}

const voidLinxBaseURL = (process.env.REACT_APP_VOID_LINX_URL || (process.env.NODE_ENV === "development" ? "http://localhost:8083" : "")).replace( /\/+$/, "" );

export const getLinkPreview = async ( url: string, signal?: AbortSignal ): Promise<ServiceReturn<RichLinkPreview>> => {
  try {
    const client = voidLinxBaseURL ? axios : api;
    const endpoint = voidLinxBaseURL ? `${ voidLinxBaseURL }/api/link-preview` : "/api/link-preview";
    const { data } = await client.get( endpoint, {
      params: { url },
      signal,
    });

    return data;
  } catch ( error: any ) {
    return {
      data: false,
      message: error?.response?.data?.message ?? error?.message,
    };
  }
};
